import { render, staticRenderFns } from "./friendlinkForm.vue?vue&type=template&id=11984113&scoped=true&"
import script from "./friendlinkForm.vue?vue&type=script&lang=js&"
export * from "./friendlinkForm.vue?vue&type=script&lang=js&"
import style0 from "./friendlinkForm.vue?vue&type=style&index=0&id=11984113&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11984113",
  null
  
)

export default component.exports